// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import PackageJson from "../../package.json"
import {type Environment} from "@environment/types"

/**
 * Configuration for preview deployments (i.e. all deployments to non-prod environments).
 */
export const environment: Environment = {
    production: true,
    name: "dev5",
    version: PackageJson.version,

    auth: {
        google: {
            clientId: "608675176242-9a7778mmllu4026o5m3ehi2n58vir03n.apps.googleusercontent.com",
        },
        microsoft: {
            clientId: "151d8cd7-eff9-441e-b8b9-1072287949cb",
        },
    },

    firebase: {
        apiKey: "AIzaSyDcRjlIVf8hDTN_shB0SlzDDvtAur2Gm8U",
        authDomain: "cm-platform-dev5.firebaseapp.com",
        projectId: "cm-platform-dev5",
        storageBucket: "cm-platform-dev5.firebasestorage.app",
        messagingSenderId: "235371753661",
        appId: "1:235371753661:web:d5478312a81050895907d4",
    },
    firebaseConfig: {
        collectionEnabled: true,
    },

    rendering: {
        materialAssets: {
            fallbackTemplateId: 17484,
            samples: 64,
        },
        shaderBall: {
            templateId: 17482,
        },
        defaultQueueDomain: "colormass",
        maxConcurrentRenderJobs: 200,
    },

    storage: {
        bucketsPrefix: "cm-platform-dev5-",
        usePostToUpload: false,
    },

    style: {
        application: {
            background: "#991b1b40",
            label: "dev5",
        },
    },

    debug: {
        enableCallStack: false,
    },

    onboarding: {
        allowSkipPayment: false,
    },

    stripe: {
        fullyIntegrated: false,
    },

    configuratorUrl: "https://configurator-dev5.colormass.com?apiVersion=2",
    platformDeployUrl: "https://dev5.colormass.com",
    configuratorDeployUrl: "https://configurator-dev5.colormass.com",
    gqlApiEndpoint: "https://gql-dev5.colormass.com",
    jobsInstanceUrl: "https://jobs-dev5.colormass.com",
    localTilingEndpoint: "ws://localhost:5678/",

    defaultRenderQueueDomain: "render",
}
